import { useLocation } from 'react-router-dom';
import { JuniWidget } from '@/modules/juni/JuniWidget';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Juni on the public site, for visitors: the marketing pages, the documentation and the legal pages.
 *
 * Not on sign-in, sign-up or password pages, where a floating button would sit over the form, and
 * not inside the dashboard, which has its own Juni that can see the customer's account.
 */
const PUBLIC_PATHS = [
  /^\/$/,
  /^\/pricing$/,
  /^\/features(\/[a-z0-9-]+)?$/,
  /^\/monitoring\/[a-z0-9-]+$/,
  /^\/guides$/,
  /^\/docs(\/[a-z0-9-]+){0,2}$/,
  /^\/contact$/,
  /^\/privacy$/,
  /^\/terms$/,
];

export function PublicJuni() {
  const { pathname } = useLocation();
  const signedIn = useAuthStore((state) => state.user !== null);

  // `/` sends a signed-in visitor on to their dashboard; the button would flash on the way.
  if ((pathname === '/' && signedIn) || !PUBLIC_PATHS.some((pattern) => pattern.test(pathname))) {
    return null;
  }

  return <JuniWidget audience="visitor" />;
}
